import type { Ref } from "vue";
import { cardClasses } from "components/Card/card.styles";
import type { MenuNavigateDetail } from "./menu.types";

export interface UseMenuFloatingPanelOptions {
  rootRef: Ref<HTMLElement | null>;
}

export const useMenuFloatingPanel = (options: UseMenuFloatingPanelOptions) => {
  const { rootRef } = options;
  const panelCardCls = cardClasses({ color: "neutral", variant: "solid", size: "xs" });

  const emitNavigate = (event: MouseEvent, to: string | undefined, target: string | undefined): void => {
    rootRef.value?.dispatchEvent(
      new CustomEvent<MenuNavigateDetail>("e-menu-navigate", {
        bubbles: true,
        composed: false,
        detail: { originalEvent: event, to, target },
      }),
    );
  };

  return { panelCardCls, emitNavigate };
};
